import Component from '../core/Component'
import Snippet from '../core/Snippet'
import { queryAll } from '../utils/dom'
import { removeComponents, loadComponents } from '../core/componentUtils'

export default class ProjectFilterSnippet extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            controls: []
        }
    }

    prepare() {
        this.snippet = new Snippet(this.element)
        this.snippet.update = this.handleUpdate

        this.controls = this.ref.controls
            .reduce((acc, element) => {
                acc[element.dataset.name] = {
                    element,
                    blocked: false,
                    id: element.dataset.name
                }

                return acc
            }, {})

        this.element.addEventListener('select:open', this.handleSelectOpen)
        this.element.addEventListener('select:close', this.handleSelectClose)
    }

    handleUpdate = ({ html }) => {
        const buffer = document.createElement('div')
        buffer.innerHTML = html

        queryAll('[data-ref="ProjectFilterSnippet:control"]', buffer)
            .forEach(element => {
                const id = element.dataset.name

                if (id in this.controls && !this.controls[id].blocked) {
                    removeComponents(this.controls[id].element)
                    this.controls[id].element.innerHTML = element.innerHTML
                    loadComponents(this.controls[id].element)
                }
            })
    }

    handleSelectOpen = event => {
        const target = event.target.closest('[data-ref="ProjectFilterSnippet:control"]')

        if (!target) {
            return
        }

        const id = target.dataset.name

        if (id in this.controls) {
            this.controls[id].blocked = true
        }
    }

    handleSelectClose = event => {
        const target = event.target.closest('[data-ref="ProjectFilterSnippet:control"]')

        if (!target) {
            return
        }

        const id = target.dataset.name

        if (id in this.controls) {
            this.controls[id].blocked = false
        }
    }
}
